<div class="video-container">
  <div class="d-flex flex-column">
    <div class="d-flex align-self-end mb-2 mr-n2">
      <a (click)="close()"><nb-icon icon="close" class="close-icon"></nb-icon></a>
    </div>
    <app-video-player [videoSources]="videoSources"></app-video-player>
  </div>
</div>
